import { range } from 'fp-ts/es6/Array';
import qs from 'query-string';

const queryString = qs.parse(location.search);
const prefId = [].concat(queryString.pref_id).slice(-1)[0]

const doChangePage = (ev: Event) => {
  ev.preventDefault();
  const target = ev.currentTarget as HTMLAnchorElement
  const query = qs.stringify({ pref_id: prefId, p: target.dataset.page }, { sort: false });
  location.href = `?${query}`;
};

const doChangePrefId =  (ev: Event) => {
  ev.preventDefault();
  const target = ev.currentTarget as HTMLSelectElement
  const prefId = target.value;

  if (range(1, 47).includes(Number(prefId))) {
    location.href = `/voice/${prefId}/`;
  } else {
    location.href = `/voice/`;
  }
}

window.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.js-change-page').forEach(el => el.addEventListener('click', doChangePage));
  document.querySelectorAll('.js-change-pref').forEach(el => el.addEventListener('change', doChangePrefId));
});
